module.exports = __webpack_public_path__ + "img/placeholder-image.588d9346.jpeg";